import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=588a65d6"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588a65d6')) {
      api.createRecord('588a65d6', component.options)
    } else {
      api.reload('588a65d6', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=588a65d6", function () {
      api.rerender('588a65d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/components/Documents.vue"
export default component.exports